import { useApiConfig } from './useApiConfig';
import { AuthenticationCodesApi } from 'osep-generator-service-client-v1';
import { Base64 } from 'base64-string';
import { useMsal } from '@azure/msal-react';

const useAuthenticationCode = () => {
  const { accounts } = useMsal();
  const { getApiConfig, axiosInstance } = useApiConfig();

  if (accounts.length === 0) {
    return { startAuthentication: undefined };
  }
  const startAuthentication = async (
    authorizationUrl: string,
    redirectUrl: string,
  ) => {
    const currentUrl = window.location.href;

    const userId = accounts[0].idTokenClaims?.sub;

    redirectUrl += `?base64DecodedUserId=${new Base64().encode(
      userId ?? '',
    )}&redirectToUi=${currentUrl}`;

    const apiConfig = await getApiConfig();

    const authenticationCodeApi = new AuthenticationCodesApi(
      apiConfig,
      undefined,
      axiosInstance,
    );
    const response = await authenticationCodeApi.createAuthenticationCode({
      redirectUrl,
    });

    const authenticationCode = response.data.authenticationCode;
    authorizationUrl += `&redirect_uri=${encodeURIComponent(
      redirectUrl,
    )}&state=${authenticationCode}`;
    window.location.href = authorizationUrl;
  };
  return { startAuthentication };
};

export default useAuthenticationCode;
